<template>
    <span>
        <b-button @click="handleLoginAsUserClick" title="Login" variant="default" class="mr-1">
            <font-awesome-icon :icon="['fas', 'circle-user']"></font-awesome-icon>
        </b-button>
        <b-button
            :href="`/app/admin/user/details/${this.subscription.user.id}`"
            title="Edit"
            variant="default"
            class="mr-1"
        >
            <font-awesome-icon :icon="['fas', 'pen-to-square']"></font-awesome-icon>
        </b-button>
        <b-button @click="handleCancelSubscriptionClick" title="Cancel" variant="default" class="mr-1">
            <font-awesome-icon :icon="['fas', 'minus']"></font-awesome-icon>
        </b-button>
        <b-button title="Add" variant="default" @click="handleAddSubscriptionClick">
            <font-awesome-icon :icon="['fas', 'plus']"></font-awesome-icon>
        </b-button>
        <modal
            :id="loginAsUserConfirmModalID"
            title="Please Confirm"
            ok-title="OK"
            @ok="handleLoginAsUser"
            @shown="onModalShown"
        >
            Are you sure you want to log in as
            <b>{{ this.subscription.user.email }}</b
            >?
        </modal>
        <modal
            :id="cancelSubscriptionConfirmModalID"
            title="Please Confirm"
            ok-title="OK"
            @ok="handleCancelSubscription"
            @shown="onModalShown"
        >
            Are you sure you want to cancel
            <b>{{ this.subscription.user.email }}</b>
            subscription?
        </modal>
        <subscription-create-modal-form
            @success-create="refresh"
            :modal-id="addSubscriptionConfirmModalID"
            :create-subscription="handleAddSubscription"
            :initial-values="initialValues"
        >
        </subscription-create-modal-form>
    </span>
</template>

<script>
    import Modal from '../../../generic/modal/modal.vue';
    import API from '../../../../api';
    import {
        SUBSCRIBER_SUBSCRIPTIONS_CREATE_ENDPOINT,
        SUBSCRIBER_SUBSCRIPTIONS_CANCEL_ENDPOINT,
    } from '../../../../endpoints';
    import SubscriptionCreateModalForm from './subscription-create-modal-form.vue';
    import { formatResponseError } from '../../../../utils/api';
    import isEmpty from 'lodash/isEmpty';

    export default {
        components: {
            Modal,
            SubscriptionCreateModalForm,
        },
        data() {
            return {
                subscription: null,
                loginAsUserConfirmModalID: '',
                cancelSubscriptionConfirmModalID: '',
                addSubscriptionConfirmModalID: '',
            };
        },
        created() {
            this.subscription = this.params.data;
            this.loginAsUserConfirmModalID = `admin-subscriptions-login-as-user-confirm-modal-${this.subscription.id}`;
            this.cancelSubscriptionConfirmModalID = `admin-subscriptions-cancel-subscription-confirm-modal-${this.subscription.id}`;
            this.addSubscriptionConfirmModalID = `admin-subscriptions-add-subscription-confirm-modal-${this.subscription.id}`;
            this.initialValues = {
                userValue: {
                    value: this.subscription.user.id,
                    text: this.subscription.user.email,
                },
                packageValue: null,
                statusValue: null,
            };
        },
        methods: {
            onModalShown() {
                this.params.api.clearFocusedCell();
            },
            handleLoginAsUserClick() {
                this.$bvModal.show(this.loginAsUserConfirmModalID);
            },
            handleLoginAsUser() {
                window.location = `/administrative/login_as_user/${this.subscription.user.id}`;
            },
            handleCancelSubscriptionClick() {
                this.$bvModal.show(this.cancelSubscriptionConfirmModalID);
            },
            handleAddSubscriptionClick() {
                this.$bvModal.show(this.addSubscriptionConfirmModalID);
            },
            refresh() {
                this.params.refresh();
            },
            async handleCancelSubscription() {
                try {
                    await API.patch(SUBSCRIBER_SUBSCRIPTIONS_CANCEL_ENDPOINT(this.subscription.id));
                    await this.params.fetchStatistics();
                    this.refresh();
                    this.successToast({
                        text: `User ${this.subscription.user.email} subscription successfully cancelled.`,
                    });
                } catch (error) {
                    const { generic } = formatResponseError(error);

                    this.errorToast({
                        text: generic || `Could not cancel ${this.subscription.user.email} subscription.`,
                    });
                }
            },
            async handleAddSubscription(payload) {
                await API.post(SUBSCRIBER_SUBSCRIPTIONS_CREATE_ENDPOINT(), payload);
                await this.params.fetchStatistics();
            },
        },
    };
</script>
